__webpack_require__.p = "https://cdn-uat.leaguespot.gg/";